module.exports = __webpack_public_path__ + "static/media/carnival.8336bc2b.jpg";